<!-- 须知文档-首页 -->
<template>
  <div class="ugd-attention-wrapper">
    <div class='cn-container'>
      <div class='cv-menu'>
        <div class='cv-menu-container'>
          <ul>
            <li v-for='(item, index) in docList'
                :key="item.title"
                :class="[(item.title === activeName) ? 'active' : '']"
                @click="goInfo(item)">{{index + 1}}.&nbsp;{{item.title}}
            </li>
          </ul>
        </div>
      </div>
      <div class='cv-main'>
        <pdf-preview :url="currentUrl"></pdf-preview>
      </div>
    </div>
  </div>
</template>

<script>
import doc from '../constant/ugd-service-support'
import PdfPreview from '@/view/undergraduate/components/pdf-preview/index'
import menteeService from '@/api/undergraduate/mentee'

export default {
  name: 'help-main',
  components: { PdfPreview },
  data () {
    return {
      testUrl: 'https://res.zailairen.com/msp/docs/1.0/1.999%20User\'s%20Manual-Mentee%20Service%20Platform.pdf',
      docList: [],
      // 当前菜单
      activeName: '',
      currentUrl: undefined
    }
  },
  computed: {},
  mounted () {
    this.activeName = 'base'
    this.getDetail()
  },
  methods: {
    getDetail () {
      menteeService.detail().then(res => {
        let data = []
        let type = res.data.model.type
        let pack = res.data.model.packageInfo && res.data.model.packageInfo.type
        for (let i = 0; i < doc.length; i++) {
          console.log(doc[i])
          if (doc[i].roles && doc[i].roles.length) {
            if (doc[i].packs && doc[i].packs.length) {
              if (doc[i].packs.includes(pack)) {
                data.push(doc[i])
              }
            } else {
              if (doc[i].roles.includes(type)) {
                data.push(doc[i])
              }
            }
          } else {
            if (doc[i].packs && doc[i].packs.length) {
              if (doc[i].packs.includes(pack)) {
                data.push(doc[i])
              }
            } else {
              data.push(doc[i])
            }
          }
        }
        this.docList = data
        this.currentUrl = data[0].url
        this.activeName = data[0].title
      })
    },
    goInfo (item) {
      this.activeName = item.title
      this.currentUrl = item.url
    }
  }
}
</script>
<style lang='less' scoped>
.cv-menu-container li {
  width: 300px;
  height: 40px;
  padding-left: 8px;
  padding-right: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #667483;
  letter-spacing: 0;
  line-height: 40px;
  &.active {
    background-image: linear-gradient(12deg, #4aa6ff 0%, #4980fd 100%);
    border-radius: 8px;
    color: #fff;
  }
}

.ugd-attention-wrapper {
    margin: 0 auto;
    padding: 60px 20px 120px;
    width: 1240px;
    .cn-container {
        display: flex;
        .cv-menu {
            flex: 0 0 200px;
            padding-right: 20px;
            height: 40px;
        }
        .cv-main {
            background: #FFFFFF;
            border-radius: 8px;
            flex: 1;
        }
    }
}
</style>
